import { render, staticRenderFns } from "./ChapterPane.vue?vue&type=template&id=522d8e4d&"
import script from "./ChapterPane.vue?vue&type=script&lang=js&"
export * from "./ChapterPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports